import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { SimpleModal, Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { ManageAccessForm } from './ManageAccessForm';
export const ManageAccessModal = observer(_ref => {
  let isEditMode = _ref.isEditMode,
    propertyData = _ref.propertyData,
    portfolioData = _ref.portfolioData,
    onSave = _ref.onSave,
    customTrigger = _ref.customTrigger,
    showModal = _ref.showModal,
    handleShowModal = _ref.handleShowModal,
    triggerRefresh = _ref.triggerRefresh,
    isBatchOp = _ref.isBatchOp;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '339-ManageAccessModal'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('team_page.manage_access')));
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    // triggerRefresh && triggerRefresh();
  };
  useEffect(() => {
    if (showModal && handleShowModal) {
      setIsModalOpen(true);
      handleShowModal(false, propertyData, portfolioData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : defaultTrigger,
    title: /*#__PURE__*/React.createElement("div", {
      className: classes.title
    }, /*#__PURE__*/React.createElement(Icon, {
      type: 'team-group',
      state: "grey"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h3"
    }, t('team_page.manage_access'))),
    subTitle: !!isBatchOp ? "You are about to configure access for ".concat(store.portfoliosMultiActionStore.selectedItems.length, " properties") : (propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress) || (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.name),
    isOpen: isModalOpen,
    handleOpen: handleModalOpen,
    handleClose: handleModalClose,
    variant: "staticHeight",
    noFooter: true,
    noPadding: true,
    noLeftButton: true
  }, /*#__PURE__*/React.createElement(ManageAccessForm, {
    isEditMode: isEditMode,
    hideNotEnabledExternal: false,
    onSave: onSave,
    propertyData: propertyData,
    portfolioData: portfolioData,
    triggerRefresh: triggerRefresh,
    isBatchOp: isBatchOp
  }));
});